'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getBadgeProps;
function getBadgeProps(_ref) {
  var fills = _ref.fills;

  /**
   * @param {boolean} isSolid
   * @param {string} color — automatic or actual color
   * @return {Object} { color, backgroundColor }
   */
  var getBadgeProps = function getBadgeProps(_ref2) {
    var isSolid = _ref2.isSolid,
        color = _ref2.color;

    var appearances = fills[isSolid ? 'solid' : 'subtle'];
    return appearances[color];
  };

  return getBadgeProps;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy90aGVtZS9zcmMvY3JlYXRlLXRoZW1lL2Jhc2UvZ2V0QmFkZ2VQcm9wcy5qcyJdLCJuYW1lcyI6WyJnZXRCYWRnZVByb3BzIiwiZmlsbHMiLCJpc1NvbGlkIiwiY29sb3IiLCJhcHBlYXJhbmNlcyJdLCJtYXBwaW5ncyI6Ijs7Ozs7a0JBQXdCQSxhO0FBQVQsU0FBU0EsYUFBVCxPQUFrQztBQUFBLE1BQVRDLEtBQVMsUUFBVEEsS0FBUzs7QUFDL0M7Ozs7O0FBS0EsTUFBTUQsZ0JBQWdCLFNBQWhCQSxhQUFnQixRQUF3QjtBQUFBLFFBQXJCRSxPQUFxQixTQUFyQkEsT0FBcUI7QUFBQSxRQUFaQyxLQUFZLFNBQVpBLEtBQVk7O0FBQzVDLFFBQU1DLGNBQWNILE1BQU1DLFVBQVUsT0FBVixHQUFvQixRQUExQixDQUFwQjtBQUNBLFdBQU9FLFlBQVlELEtBQVosQ0FBUDtBQUNELEdBSEQ7O0FBS0EsU0FBT0gsYUFBUDtBQUNEIiwiZmlsZSI6ImdldEJhZGdlUHJvcHMuanMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBnZXRCYWRnZVByb3BzKHsgZmlsbHMgfSkge1xuICAvKipcbiAgICogQHBhcmFtIHtib29sZWFufSBpc1NvbGlkXG4gICAqIEBwYXJhbSB7c3RyaW5nfSBjb2xvciDigJQgYXV0b21hdGljIG9yIGFjdHVhbCBjb2xvclxuICAgKiBAcmV0dXJuIHtPYmplY3R9IHsgY29sb3IsIGJhY2tncm91bmRDb2xvciB9XG4gICAqL1xuICBjb25zdCBnZXRCYWRnZVByb3BzID0gKHsgaXNTb2xpZCwgY29sb3IgfSkgPT4ge1xuICAgIGNvbnN0IGFwcGVhcmFuY2VzID0gZmlsbHNbaXNTb2xpZCA/ICdzb2xpZCcgOiAnc3VidGxlJ11cbiAgICByZXR1cm4gYXBwZWFyYW5jZXNbY29sb3JdXG4gIH1cblxuICByZXR1cm4gZ2V0QmFkZ2VQcm9wc1xufVxuIl19